import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import AdminLayout from './layouts/AdminLayout';
import EmpleadoLayout from './layouts/EmpleadoLayout';
import TotemLayout from './layouts/TotemLayout';
import { obtenerSesion, guardarSesion, cerrarSesion, inicializarMonitoreoActividad, limpiarMonitoreoActividad } from './services/sessionManager';

function App() {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Detectar si está en modo totem por URL
    const path = window.location.pathname;
    if (path.includes('/totem')) {
      setLoading(false);
      return;
    }

    // Verificar si hay usuario guardado en sessionStorage (solo para web/admin)
    const usuarioGuardado = obtenerSesion();
    if (usuarioGuardado) {
      setUsuario(usuarioGuardado);
      // Inicializar monitoreo de actividad
      inicializarMonitoreoActividad();
    }
    setLoading(false);

    // Cleanup al desmontar
    return () => {
      limpiarMonitoreoActividad();
    };
  }, []);

  const handleLogin = (user) => {
    setUsuario(user);
    guardarSesion(user);
    // Inicializar monitoreo de actividad después del login
    inicializarMonitoreoActividad();
  };

  const handleLogout = () => {
    setUsuario(null);
    cerrarSesion();
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Cargando...</p>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        {/* Ruta Totem - Sin login, directo al flujo */}
        <Route path="/totem" element={<TotemLayout />} />
        
        {/* Rutas Web/Admin - Con login */}
        <Route
          path="/*"
          element={
            !usuario ? (
              <Login onLogin={handleLogin} />
            ) : (usuario.tipo_usuario === 'admin' || usuario.tipo_usuario === 'super_admin') ? (
              <AdminLayout usuario={usuario} onLogout={handleLogout} />
            ) : (
              <EmpleadoLayout usuario={usuario} onLogout={handleLogout} />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
